import { getHistory, getStaffHistory } from './history.action';

export { historyReducer } from './history.reducer';
export { watchHistory } from './history.saga';

export const historyActions = {
    getHistory,
    getStaffHistory,
};
